export enum AttentionLevel {
    Expired = "Expired",
    Ok = "Ok",
    Warning = "Warning",
    Alert = "Alert"
}